import { createReducer } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    inventoryItem: null,
    allStoresItems: [],
    singleStoreItems: [],
    lowStockItems: [],
    outOfStockItems: [],
    inventoryStats: null,
    inventoryValue: 0,
    success: false,
    error: null,
    message: null,
};

export const storeInventoryReducer = createReducer(initialState, (builder) => {
    builder
        // Create Inventory Item
        .addCase('createInventoryItemRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('createInventoryItemSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('createInventoryItemFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Fetch All Stores Items
        .addCase('getAllStoresItemsRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getAllStoresItemsSuccess', (state, action) => {
            state.isLoading = false;
            state.allStoresItems = action.payload;
        })
        .addCase('getAllStoresItemsFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Fetch Single Store Items
        .addCase('getSingleStoreItemsRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getSingleStoreItemsSuccess', (state, action) => {
            state.isLoading = false;
            state.singleStoreItems = action.payload;
        })
        .addCase('getSingleStoreItemsFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        // Edit Store Inventory Item
        .addCase('editStoreInventoryItemRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('editStoreInventoryItemSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('editStoreInventoryItemFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Add Inventory Quantity to an Item
        .addCase('addInventoryQuantityRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('addInventoryQuantitySuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('addInventoryQuantityFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Remove Inventory Quantity from an Item
        .addCase('removeInventoryQuantityRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('removeInventoryQuantitySuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('removeInventoryQuantityFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Deduct Inventory Quantity from an Item
        .addCase('deductInventoryQuantityRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deductInventoryQuantitySuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('deductInventoryQuantityFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Transfer Inventory Item
        .addCase('transferInventoryItemRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('transferInventoryItemSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('transferInventoryItemFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Get Inventory Item Details
        .addCase('getInventoryItemDetailsRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getInventoryItemDetailsSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
        })
        .addCase('getInventoryItemDetailsFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        // Activate or Deactivate Store Inventory Item
        .addCase('toggleInventoryItemStatusRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('toggleInventoryItemStatusSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('toggleInventoryItemStatusFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Delete Inventory Item
        .addCase('deleteInventoryItemRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deleteInventoryItemSuccess', (state, action) => {
            state.isLoading = false;
            state.message = action.payload;
        })
        .addCase('deleteInventoryItemFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Delete Inventory Activity
        .addCase('deleteInventoryActivityRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deleteInventoryActivitySuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('deleteInventoryActivityFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Delete Reconciliation Record
        .addCase('deleteReconciliationRecordRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deleteReconciliationRecordSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('deleteReconciliationRecordFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Get store inventory value
        .addCase('getInventoryValueRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getInventoryValueSuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryValue = action.payload;
        })
        .addCase('getInventoryValueFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // reconcile inventory
        .addCase('reconcileInventoryRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('reconcileInventorySuccess', (state, action) => {
            state.isLoading = false;
            state.inventoryItem = action.payload;
            state.success = true;
        })
        .addCase('reconcileInventoryFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Clear Errors
        .addCase('clearErrors', (state) => {
            state.error = null;
        })

        // Clear Success Messages
        .addCase('clearSuccess', (state) => {
            state.message = null;
            state.success = false;
        })

        // Clear All Stores Items
        .addCase('clearAllStoresItems', (state) => {
            state.allStoresItems = [];
        })

        // Clear Single Store Items
        .addCase('clearSingleStoreItems', (state) => {
            state.singleStoreItems = [];
        });
});
